import { useMemo } from 'react';
import { PERMISSION_LEVELS } from '../Utils/constants';

/**
 * Hook to manage user permissions
 */
export const usePermissions = (permishId) => {
  const permissions = useMemo(() => {
    const permissionId = parseInt(permishId);
    const isRestricted = permissionId === PERMISSION_LEVELS.RESTRICTED;
    
    return {
      permissionId,
      isRestricted,
      canEdit: !isRestricted,
      canDelete: !isRestricted,
      canCreate: !isRestricted
    };
  }, [permishId]);

  return permissions;
};
